module.exports = __webpack_public_path__ + "static/media/Darwin_Editor_invert.6f06ea5b.svg";